import { css } from '@/styled-system/css';

export const bannerActionRecipe = css.raw({
  color: 'inherit',
  flex: '0 0 auto',
});
